enum OrderChannel {
  Catering = 'catering',
  DriveThru = 'drive-thru',
  Flash = 'flash',
  Kiosk = 'kiosk',
  Linebuster = 'linebuster',
  Web = 'web',
}

export { OrderChannel };
